import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTranslation } from "react-i18next";
import { digitalNoticeBoxStyle } from "../styles/styles";

/**
 * Digital-delivery notice (COMY1-334). Shown on a job whose order carries a
 * digital item — a product the supplier flagged as digital, or an online
 * service — because nothing gets shipped or collected: the supplier has to
 * send it to the client directly.
 */
const DigitalDeliveryNotice = () => {
  const { t } = useTranslation("view-job-modal");

  return (
    <Box sx={digitalNoticeBoxStyle}>
      <InfoOutlinedIcon
        sx={{ fontSize: "18px", color: "rgba(28, 160, 138, 1)", mt: "1px" }}
      />
      <Typography>{t("digital_delivery_notice")}</Typography>
    </Box>
  );
};

export default DigitalDeliveryNotice;
